export { PrivacyPolicyModal } from './PrivacyPolicyModal';
